import { IconTiny, IconVeryTiny } from '@/widgets/components/icon';
import { InvisibleButton } from '@/widgets/components/invisible-button';
import { chartThemes } from '@/constants';
import styled from 'styled-components';

export const typeToStyles = {
  [chartThemes.PROPERTY_DETAILS]: {
    marginBottom: '0px',
    labelFontSize: '12px',
    valueFontSize: '16px',
  },
  [chartThemes.DASHBOARD]: {
    marginBottom: '0px',
    labelFontSize: '14px',
    valueFontSize: '18px',
  },
  [chartThemes.DASHBOARD_PRINT]: {
    marginBottom: '20px',
    labelFontSize: '14px',
    valueFontSize: '28px',
  },
  [chartThemes.MODAL]: {
    marginBottom: '50px',
    labelFontSize: '16px',
    valueFontSize: '32px',
  },
};

export const Wrapper = styled.div`
  margin-top: 26px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 45px;
`;

export const IconWrapper = styled.div`
  height: 42px;
  width: 42px;
`;

export const ItemWrapper = styled(InvisibleButton)`
  display: flex;
  flex-direction: row;
  padding: 0;
  margin: 0;
`;

export const ItemDataWrapper = styled.div`
  margin-left: 20px;
  display: flex;
  flex-direction: column;
`;

export const ItemData = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 10px;

  svg {
    margin-left: 20px;
  }
`;

export const ItemNumber = styled.div`
  font-size: ${(props) => (props.fontSize ? props.fontSize : '18px')};
  min-height: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  color: ${(props) => (props.active ? '#101938' : 'rgba(0, 0, 0, 0.5)')};
`;

export const ItemSymbol = styled.div`
  font-size: ${(props) => (props.small ? '12px' : '20px')};
  margin-left: ${(props) => (props.margin ? '5px' : '0px')};
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  color: '#101938';
`;

export const ItemLabelWrapper = styled.div`
  margin-top: 2px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 20px;
  font-size: 12px;
  font-weight: 800;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${(props) => props.color};

  svg {
    margin-left: 9px;
  }
`;

export const IconRise = styled(IconTiny)`
  color: #abd400;
`;

export const IconFall = styled(IconTiny)`
  color: #ff47b4;
`;

export const IconHome = styled(IconVeryTiny)`
  color: #101938;
  && {
    margin-left: 3px;
  }
`;

/**
 * Wrapper for header of small cards
 */
export const HeaderWrapperSm = styled.div`
  margin-bottom: ${(props) => props.marginBottom};
`;

// TODO: we need to unify labels for cards and charts. We have some code duplication here
export const LabelSm = styled.div`
  height: 17px;
  font-size: ${(props) => `${props.fontSize}`};
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  margin-bottom: ${(props) =>
    props.marginUnderLabel ? `${props.marginUnderLabel}px` : ''};
  color: #101938;
  text-align: left;
`;

export const DataWrapperSm = styled.div`
  display: flex;
  justify-content: space-between;
  /* margin-top: ${(props) => (props.compact ? '0px' : '16px')}; */
`;

export const ColumnSm = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ColumnLabelSm = styled.div`
  color: ${(props) => props.color};
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: normal;
`;

export const ColumnValueSm = styled.div`
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #101938;
`;

export const OPColumnSm = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;

  > div:last-child {
    margin-top: 6px;
  }
`;

export const DataUnavailableMsg = styled.div`
  margin-top: 10px;
`;
